const StoreCheckout = `
    store_flg,          guest_checkout,                         false,          71;
    store_flg,          offline_payment,                        false,          73;
`

export default StoreCheckout;